import { Close } from "@mui/icons-material";
import { Drawer, IconButton, useMediaQuery, } from "@mui/material";
import TourDrawerDetails from "./tour-drawer-details.component";
import TourDrawerSkeleton from "./tour-drawer-skeleton.component";
import { useToursContext } from '../../../contexts/tour-context';

export default function TourDrawer({ clickedTourData }) {

    const { isTourDrawerOpened, setIsTourDrawerOpened } = useToursContext();
    const matches = useMediaQuery('(min-width:600px)');
    const WIDTH = { xs: '100%', sm: '40%', md: '35%', lg: '30%' };

    function closeDrawerHandler() {
        setIsTourDrawerOpened(false)
    }

    return (
        <Drawer
            open={isTourDrawerOpened}
            onClose={() => closeDrawerHandler()}
            key={clickedTourData?.id}
            variant={"persistent"}
            anchor={"right"}
            sx={{
                '.MuiDrawer-paper': {
                    boxSizing: 'border-box',
                    position: 'absolute', height: { xs: '100%', sm: '100%' }, ml: { xs: 0, sm: 3 }, mr: { xs: 0, sm: 3 }, borderRadius: 2, right: 'unset',
                    bgcolor: "#F7F7F7", border: "1px solid #DBDBDB", width: WIDTH, overflowX: 'hidden', overflowY: 'auto'
                }
            }}
        >
            {!matches && <IconButton onClick={() => closeDrawerHandler()}
                sx={{
                    position: 'absolute', top: 5, right: 5, p: '1px',
                    background: 'white', zIndex: 10,
                    ':hover': { bgcolor: 'rgb(255 255 255 / 50%)' }
                }}>
                <Close />
            </IconButton>}
            {!clickedTourData ?
                <TourDrawerSkeleton />
                :
                <TourDrawerDetails clickedTourData={clickedTourData} />
            }

        </Drawer >

    )
}